var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 0H4C1.79086 0 0 1.79086 0 4V24C0 26.2091 1.79086 28 4 28H18V32H13C12.4477 32 12 32.4477 12 33C12 33.5523 12.4477 34 13 34H18H22H27C27.5523 34 28 33.5523 28 33C28 32.4477 27.5523 32 27 32H22V28H36C38.2091 28 40 26.2091 40 24V4C40 1.79086 38.2091 0 36 0ZM22 26H36C37.1046 26 38 25.1046 38 24V4C38 2.89543 37.1046 2 36 2H4C2.89543 2 2 2.89543 2 4V24C2 25.1046 2.89543 26 4 26H18H22Z",
    fill: "#50B247"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/Desktop.76dd821bf73961d4df26b22149ed1bd8.svg";
export { ForwardRef as ReactComponent };